import { render, staticRenderFns } from "./allUser.vue?vue&type=template&id=776a4f66"
import script from "./allUser.vue?vue&type=script&lang=ts"
export * from "./allUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports